/**
 * Formatação de exibição. Nada aqui muda valor gravado.
 */

/**
 * CPF legível: `427.049.218-06`.
 *
 * O SAGA entrega os dois jeitos — `42704921806` em uns registros e
 * `526.351.258–99` em outros —, e a coluna fica ilegível com as duas formas
 * misturadas.
 *
 * NORMALIZA ANTES DE FORMATAR. A pontuação que vem é descartada, inclusive o
 * travessão tipográfico `–` (U+2013), que aparece em pelo menos um registro e
 * NÃO é o hífen comum: um `replace('-', '')` ingênuo deixaria ele passar e o
 * resultado teria doze caracteres.
 *
 * VALOR QUE NÃO TEM 11 DÍGITOS SAI COMO VEIO. Há conta de sistema com CPF
 * `1939`; enquadrar isso no formato produziria `19.3` ou coisa pior — um
 * número inventado parecendo CPF. Mostrar cru é honesto e deixa a anomalia
 * visível, que é o que permite alguém corrigir no SAGA.
 *
 * NÃO BRIGA COM A MÁSCARA DE PRIVACIDADE. O editor recebe do servidor
 * `•••.•••.•••-02`, que tem dois dígitos — cai na regra dos 11 e volta
 * intacto. A máscara tem precedência porque chega antes: o que o servidor não
 * manda, esta função não tem como revelar.
 */
export function formatarCpf(cpf: string | null): string | null {
  if (cpf === null) return null;
  const digitos = cpf.replace(/\D+/g, '');
  if (digitos.length !== 11) return cpf;
  return `${digitos.slice(0, 3)}.${digitos.slice(3, 6)}.${digitos.slice(6, 9)}-${digitos.slice(9)}`;
}

/**
 * E-mail em caixa baixa.
 *
 * O SAGA tem registros em caixa alta (`ALANPIRONDI12@ICLOUD.COM`) e outros em
 * minúscula. Domínio não distingue caixa, e a coluna fica mais calma com uma
 * forma só. Exibição apenas — o valor gravado continua como veio.
 */
export function formatarEmail(email: string | null): string | null {
  return email === null ? null : email.toLowerCase();
}
